import React from 'react';

import { styled } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Root = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  maxWidth: '100%',
  verticalAlign: 'middle',
});

const Text = styled('span')({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const InfoIcon = styled(InfoOutlinedIcon)({
  flexShrink: 0,
  fontSize: 16,
});

type InfoLabelProps = {
  children: React.ReactNode;
};

const InfoLabel: React.FC<InfoLabelProps> = ({ children }) => (
  <Root>
    <Text>{children}</Text>
    <InfoIcon />
  </Root>
);

export default InfoLabel;
